import React from 'react'

import { WiderButtonType } from '../../../common/widebutton.type'
import IconText from '../../UtilComponent/level_1/IconText'
import LinkButton from './LinkButton'

const WiderButton: React.FC<WiderButtonType> = (props) => {
  const { urlPath, IconComponent, text } = props

  return (
    <div className="text-small ">
      <LinkButton urlPath={urlPath}>
        <IconText Icon={IconComponent} text={text} />
      </LinkButton>
    </div>
  )
}

export default WiderButton
